import ChatService from '@/services/chatService';

export const chat = {
  namespaced: true,
  
  actions: {
    getMessages({ commit }: any, data: any) {
      return ChatService.getMessages(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    getMessage({ commit }: any, data: any) {
      return ChatService.getMessage(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },      
    updateMessages({ commit }: any, data: any) {
      return ChatService.updateMessages(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    editMessage({ commit }: any, data: any) {
      return ChatService.editMessage(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    sendMessage({ commit }: any, data: any) {
      return ChatService.sendMessage(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    sendMessageFiles({ commit }: any, data: { filesData: any, config: any }) {
      return ChatService.sendMessageFiles(data.filesData, data.config).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    deleteMessageFiles({ commit }: any, data: any) {
      return ChatService.deleteMessageFiles(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    sendMessageReaction({ commit }: any, data: any) {
      return ChatService.sendMessageReaction(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    createRooms({ commit }: any, data: any) {
      return ChatService.createRooms(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    getRooms({ commit }: any, data: any) {
      return ChatService.getRooms(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    markMessagesSeen({ commit }: any, data: any) {
      return ChatService.markMessagesSeen(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    markMessagesRead({ commit }: any, data: any) {
      return ChatService.markMessagesRead(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    markMessagesDistributed({ commit }: any, data: any) {
      return ChatService.markMessagesDistributed(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
    setLastRoomMessage({ commit }: any, data: any) {
      return ChatService.setLastRoomMessage(data).then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          alert("error");
  
          return Promise.reject(error);
        }
      );
    },
  },
};

export default chat;